import type {SalesCatalogManifest,SalesCatalogSnapshot,SnapshotListing} from './types';
interface DeltaPage {
  baseVersion:number;version:number;checksum:string;rowCount:number;completedAt:string|null;
  changes:{key:string;operation:'upsert'|'delete';item:SnapshotListing|null}[];
  next:{source:string;id:string}|null;
}
export async function loadCatalogueDeltas(base:SalesCatalogManifest,items:SnapshotListing[],
  read:(path:string)=>Promise<DeltaPage>):Promise<SalesCatalogSnapshot> {
  const current=new Map(items.map(item=>[item.key,item]));
  let head:DeltaPage|null=null,cursor:{source:string;id:string}|null=null;
  const cursors=new Set<string>();
  for(let page=0;page<1000;page++){
    const query=new URLSearchParams({baseVersion:String(base.version)});
    if(head)query.set('version',String(head.version));
    if(cursor){query.set('afterSource',cursor.source);query.set('afterId',cursor.id);}
    const delta=await read(`/api/sales/changes?${query}`);
    if(delta.baseVersion!==base.version||(head&&delta.checksum!==head.checksum))throw new Error('Версия изменений каталога не совпадает');
    head??=delta;
    for(const change of delta.changes){
      if(change.operation==='delete')current.delete(change.key);
      else if(change.item?.key===change.key)current.set(change.key,change.item);
      else throw new Error('Некорректное изменение товара');
    }
    if(!delta.next){
      if(current.size!==head.rowCount)throw new Error('Изменения каталога загружены не полностью');
      return {version:head.version,checksum:head.checksum,completedAt:head.completedAt,
        rowCount:head.rowCount,items:[...current.values()]};
    }
    const key=JSON.stringify(delta.next);if(cursors.has(key))throw new Error('Повтор курсора каталога');
    cursors.add(key);cursor=delta.next;
  }
  throw new Error('Слишком много страниц изменений каталога');
}
